import _define_property from "@swc/helpers/src/_define_property.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import { ArticleHeader, ContainerArticle, DetailsPage, MainArticle } from "styles/jss/Layout.styles";
import { Box, Container, Divider, useTheme } from "@mui/material";
import { DateStamp, PostContent, Redirect, EndDateStamp } from "components";
import { PageContainer } from "components/PagesComponents";
import { isEmpty } from "utils/helperFunction";
import { getTAList } from "services/tenders&auctions.api";
function TendersAuctionsPage() {
    var ref;
    var ref1 = useRouter(), locale = ref1.locale, query = ref1.query;
    var t = useTranslation("article").t;
    var theme = useTheme();
    var ref2 = useQuery([
        "tender-".concat(query.id)
    ], function() {
        return getTAList(locale, {
            filters: {
                slug: {
                    $eq: query.slug
                },
                id: {
                    $eq: query.id
                }
            }
        });
    }), _data = ref2.data, _data1 = _sliced_to_array(_data.data, 1), tenderDetails = _data1[0];
    if (!tenderDetails) {
        return /*#__PURE__*/ _jsx(Redirect, {});
    }
    return /*#__PURE__*/ _jsx(PageContainer, {
        seo_info: {
            title: tenderDetails.attributes.title,
            description: tenderDetails.attributes.short_description,
            image: (ref = tenderDetails.attributes.thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats
        },
        banner: tenderDetails.attributes.thumbnail,
        children: /*#__PURE__*/ _jsx(DetailsPage, {
            children: /*#__PURE__*/ _jsx(Container, {
                sx: _define_property({
                    mt: "40px"
                }, theme.breakpoints.down("md"), {
                    px: "0",
                    mt: "0"
                }),
                children: /*#__PURE__*/ _jsx(MainArticle, {
                    children: /*#__PURE__*/ _jsxs(ContainerArticle, {
                        children: [
                            /*#__PURE__*/ _jsxs(ArticleHeader, {
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "title",
                                        children: tenderDetails.attributes.title
                                    }),
                                    /*#__PURE__*/ _jsxs(Box, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(DateStamp, {
                                                date: tenderDetails.attributes.datetime,
                                                time: true
                                            }),
                                            !!tenderDetails.attributes.end_datetime && /*#__PURE__*/ _jsx(EndDateStamp, {
                                                date: tenderDetails.attributes.end_datetime
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: _define_property({
                                    my: "60px"
                                }, theme.breakpoints.down("md"), {
                                    my: "20px",
                                    mx: "16px"
                                })
                            }),
                            /*#__PURE__*/ _jsx(PostContent, {
                                description: tenderDetails.attributes.description
                            }),
                            !isEmpty(tenderDetails.attributes.attachment) && /*#__PURE__*/ _jsxs("div", {
                                className: "attachment",
                                children: [
                                    /*#__PURE__*/ _jsxs("p", {
                                        children: [
                                            t("tender.attachment"),
                                            " :"
                                        ]
                                    }),
                                    tenderDetails.attributes.attachment.map(function(item) {
                                        return /*#__PURE__*/ _jsx("a", {
                                            className: "downloadFile",
                                            href: process.env.BASE_URL + item.file.data.attributes.url,
                                            download: true,
                                            children: item.file_name
                                        }, item.id);
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(TendersAuctionsPage);
